import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "d-flex align-items-center justify-content-between gap-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bold" }, "Daily Report Status", -1)
const _hoisted_5 = { class: "d-flex gap-4" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { style: {"margin-left":"10px"} }
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-content-end mt-5"
}

import { ref, onMounted } from "vue";
import { ElMessage } from "element-plus";
import SystemService from "@/projects/tenant/modules/system/services/SystemService";
import moment from "moment";
import { AccountReportStatusTypes } from "@/core/types/AccountReportStatusTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'ReportStatus',
  setup(__props) {

const date = ref(moment().format("YYYY-MM-DD"));
const data = ref<any>([]);
const isLoading = ref(false);
const isSending = ref(false);

const fetchData = async () => {
  isLoading.value = true;
  try {
    const res = await SystemService.queryReportStatus(date.value);
    data.value = res;
    console.log("Report Status Data:", data.value);
  } catch (e) {
    console.log(e);
  } finally {
    isLoading.value = false;
  }
};

const sendDailyReport = async () => {
  // Check if there is data to send
  if (!data.value || data.value.length === 0) {
    ElMessage.warning(
      "No data available to send. Please search for data first."
    );
    return;
  }

  isSending.value = true;
  try {
    await SystemService.sendDailyReportStatus(date.value);
    console.log("Daily report sent successfully for date:", date.value);
    ElMessage.success("Daily report sent successfully!");
  } catch (e) {
    console.log("Error sending daily report:", e);
    ElMessage.error("Failed to send daily report. Please try again.");
  } finally {
    isSending.value = false;
  }
};

onMounted(() => {
  // fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_date_picker, {
            modelValue: date.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((date).value = $event)),
            type: "date",
            placeholder: "Pick a day",
            style: {"width":"150px"},
            disabled: isLoading.value,
            "value-format": 'YYYY-MM-DD'
          }, null, 8, ["modelValue", "disabled"]),
          _createVNode(_component_el_button, {
            type: "warning",
            onClick: fetchData,
            loading: isLoading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: data.value,
        size: "small"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('fields.status')
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(AccountReportStatusTypes)[scope.row.status]) + " (" + _toDisplayString(scope.row.status) + ")", 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "count",
            label: _ctx.$t('fields.counts'),
            align: "center"
          }, null, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, isLoading.value]
      ]),
      (_ctx.$can('SuperAdmin'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: sendDailyReport,
              loading: isSending.value,
              size: "medium"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.send")), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})